<!--
An input allowing the user to select one of a number of options.

You must set an 'options' propety, which is an object of {value: label}.
Use v-model to bind the selected value to a variable in your object, e.g.

<toggle :options="{a: 'Option A', b: 'Option B'}" v-model="selectedOption" />
You have selected {{ selectedOption }}

...

data: function () {
	return {
		selectedOption: 'b',
	};
}
-->

<template>
	<div class="toggle">
		<label v-for="(label, id) in options" :key="id" :data-value="id" :class="{active: selected == id}" @click="selected = id">
			{{ label }}
		</label>
	</div>
</template>

<script>
export default {
	// Initialize the selected item with the value passed in as a property.
	data: function () {
		return {
			selected: this.value,
		};
	},
	props: {
		// Selectable options, as an object of {value: label}.
		options: {
			type: Object,
			required: true,
		},
		// The currently selected value.
		value: {
			type: String,
			required: false,
		},
	},
	watch: {
		// Notify the parent when the selection is changed.
		selected: function (val) {
			this.$emit('input', val);
		}
	}
}
</script>
